<template>

    <div class="container">

        <h3 class="padding">Our records indicate that your account is currently on hold.</h3>

        <h3 class="padding">Please contact our team who will be happy to advise and enable you to place your order
            again.</h3>

        <div class="padding">
            <p>Ravensworth Client Services:</p>
            <p class="teal">0191 917 9331</p>
            <p class="teal">client.support@ravensworth.co.uk</p>
        </div>

        <div class="padding">
            <p>Please close this window</p>
        </div>
    </div>

</template>

<script>

    export default {
        name: "onhold",
        components: {},
        data() {
            return {}
        },
        created() {
        },
        methods: {}
    };
</script>